var React = require('react');

function YoutubeOrangeInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M33.5929 0.795294C35.2073 1.22353 36.4802 2.47765 36.9149 4.06824C37.7221 6.97412 37.6911 13.0306 37.6911 13.0306C37.6911 13.0306 37.6911 19.0565 36.9149 21.9624C36.4802 23.5529 35.2073 24.8071 33.5929 25.2353C30.6434 26 18.8455 26 18.8455 26C18.8455 26 7.07872 26 4.09821 25.2047C2.48376 24.7765 1.21083 23.5224 0.776175 21.9318C0 19.0565 0 13 0 13C0 13 0 6.97412 0.776175 4.06824C1.21083 2.47765 2.51481 1.19294 4.09821 0.764706C7.04767 0 18.8455 0 18.8455 0C18.8455 0 30.6434 0 33.5929 0.795294ZM24.9002 13L15.0894 7.43298V18.5671L24.9002 13Z","fill":"#F4B468"}));
}

YoutubeOrangeInline.defaultProps = {"width":"38","height":"26","viewBox":"0 0 38 26","fill":"none"};

module.exports = YoutubeOrangeInline;

YoutubeOrangeInline.default = YoutubeOrangeInline;
